<div class="container-fluid complyon-page controls-library-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell controls-library-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title controls-library-title mb-2 text-l">Controls library</h1>
      <p class="complyon-subtitle controls-library-subtitle mb-0 text-s">
        Control owner, frequency, evidence requirement, testing status and linked risk.
      </p>
    </section>

    <section class="controls-library-toolbar d-flex align-items-start justify-content-between gap-3 mb-3">
      <div class="controls-library-tab-bar d-flex flex-wrap align-items-center">
        <button v-for="tab in tabs" :key="tab.id" type="button"
          class="btn controls-library-tab-btn d-inline-flex align-items-center gap-2"
          :class="{ active: active_tab === tab.id }" @click="set_tab(tab.id)">
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== null" class="controls-library-tab-count">{{ tab.count }}</span>
        </button>
      </div>
      <button type="button"
        class="btn btn-link controls-library-reset-btn text-decoration-none d-inline-flex align-items-center gap-2">
        <i class="bi bi-arrow-counterclockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'register'">
      <section class="row g-3 mb-3">
        <div v-for="card in register_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card controls-library-card rounded-4 p-3 h-100">
            <div class="controls-library-stat-label text-xs">{{ card.label }}</div>
            <div class="controls-library-stat-value" :class="`is-${card.accent}`">{{ card.value }}</div>
            <div class="controls-library-stat-note text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel controls-library-panel rounded-4 overflow-hidden">
        <div class="controls-library-panel-head d-flex align-items-start justify-content-between gap-3 px-3 pt-3 pb-3">
          <div>
            <div class="controls-library-section-title text-s">The glue between policy and real action - connects to
            </div>
            <div class="controls-library-section-subtitle text-xs">
              Each control links a policy rule to live records across the platform, and escalates into Risk, Incidents,
              Audit and Reports when it fails.
            </div>
          </div>
          <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2" @click="open_control_modal()">
            <i class="bi bi-plus"></i>
            <span>Add control</span>
          </button>
        </div>

        <div class="controls-library-chip-section px-3 pb-3">
          <div class="controls-library-chip-wrap">
            <router-link
              v-for="chip in register_chips"
              :key="chip.label"
              :to="{ name: chip.route_name }"
              class="controls-library-chip text-decoration-none"
            >
              <i class="bi" :class="chip.icon"></i>
              <span>{{ chip.label }}</span>
            </router-link>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table controls-library-table controls-library-table--register align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3">Ref</th>
                <th>Control</th>
                <th>Category</th>
                <th>Owner</th>
                <th>Frequency</th>
                <th>Linked risk</th>
                <th>Result</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in register_rows" :key="row.id"
                :class="{ 'controls-library-row-highlight': row.highlighted }"
                class="controls-library-row"
                role="button"
                tabindex="0"
                @click="open_control_drawer(row)"
                @keydown.enter.prevent="open_control_drawer(row)"
                @keydown.space.prevent="open_control_drawer(row)">
                <td class="ps-3">
                  <div class="controls-library-id">{{ row.id }}</div>
                </td>
                <td>
                  <div class="controls-library-control">{{ row.control }}</div>
                  <div v-if="row.control_subtitle" class="controls-library-control-subtitle">{{ row.control_subtitle }}
                  </div>
                </td>
                <td><span class="controls-library-pillar-badge">{{ row.category }}</span></td>
                <td>{{ row.owner }}</td>
                <td>{{ row.frequency }}</td>
                <td>{{ row.linked_risk }}</td>
                <td><span class="badge complyon-badge controls-library-badge" :class="row.result.class">{{
                    row.result.label }}</span></td>
                <td class="controls-library-arrow-cell"><i class="bi bi-chevron-right"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'category'">
      <section class="row g-3">
        <div v-for="card in category_cards" :key="card.title" class="col-12 col-md-6 col-xl-4">
          <article class="controls-library-category-card complyon-card rounded-4 p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="d-flex align-items-center gap-2">
                <span class="controls-library-category-icon"><i class="bi" :class="card.icon"></i></span>
                <div class="controls-library-category-title">{{ card.title }}</div>
              </div>
              <span class="controls-library-effective-badge" :class="`is-${card.tone}`">{{ card.effective }}</span>
            </div>
            <div class="controls-library-category-summary mt-3">
              <strong>{{ card.count }}</strong>
              <span v-if="card.failing" class="controls-library-category-failing">{{ card.failing }}</span>
            </div>
            <div class="controls-library-category-progress mt-3" :class="`is-${card.tone}`">
              <span :style="{ width: `${card.progress}%` }"></span>
            </div>
            <ul class="controls-library-category-list mt-3 mb-0">
              <li
                v-for="item in card.items"
                :key="typeof item === 'string' ? item : item.text"
                :class="[
                  `is-${typeof item === 'string' ? card.tone : item.tone}`,
                  'controls-library-category-list-item'
                ]"
                role="button"
                tabindex="0"
                @click="open_control_drawer(typeof item === 'string' ? null : item.drawer_key)"
                @keydown.enter.prevent="open_control_drawer(typeof item === 'string' ? null : item.drawer_key)"
                @keydown.space.prevent="open_control_drawer(typeof item === 'string' ? null : item.drawer_key)"
              >
                {{ typeof item === 'string' ? item : item.text }}
              </li>
            </ul>
          </article>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'testing'">
      <section class="row g-3 mb-3">
        <div v-for="card in testing_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card controls-library-card rounded-4 p-3 h-100">
            <div class="controls-library-stat-label text-xs">{{ card.label }}</div>
            <div class="controls-library-stat-value" :class="`is-${card.accent}`">{{ card.value }}</div>
            <div class="controls-library-stat-note text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel controls-library-panel rounded-4 overflow-hidden">
        <div class="px-3 pt-3">
          <div class="controls-library-section-title text-s">Control testing results</div>
          <div class="controls-library-section-subtitle text-xs">Passed - partially effective - failed - not tested -
            sorted by what needs attention.</div>
        </div>
        <div class="table-responsive">
          <table class="table controls-library-table controls-library-table--testing align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3">Ref</th>
                <th>Control</th>
                <th>Owner</th>
                <th>Frequency</th>
                <th>Last tested</th>
                <th>Next due</th>
                <th>Result</th>
                <th></th>
              </tr>
            </thead>
              <tbody>
                <tr v-for="row in testing_rows" :key="`${row.id}-${row.last_tested}`"
                  class="controls-library-row"
                  :class="{ 'controls-library-row-highlight': row.highlighted }"
                  role="button"
                  tabindex="0"
                  @click="open_control_drawer(row)"
                  @keydown.enter.prevent="open_control_drawer(row)"
                  @keydown.space.prevent="open_control_drawer(row)">
                  <td class="ps-3">
                    <div class="controls-library-id">{{ row.id }}</div>
                  </td>
                <td class="controls-library-control-cell">{{ row.control }}</td>
                <td>{{ row.owner }}</td>
                <td>{{ row.frequency }}</td>
                <td class="controls-library-date">{{ row.last_tested }}</td>
                <td>{{ row.next_due }}</td>
                <td><span class="badge complyon-badge controls-library-badge" :class="row.result.class">{{
                    row.result.label }}</span></td>
                <td class="controls-library-arrow-cell"><i class="bi bi-chevron-right"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else>
      <section class="row g-3 mb-3">
        <div v-for="card in remediation_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card controls-library-card rounded-4 p-3 h-100">
            <div class="controls-library-stat-label text-xs">{{ card.label }}</div>
            <div class="controls-library-stat-value" :class="`is-${card.accent}`">{{ card.value }}</div>
            <div class="controls-library-stat-note text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel controls-library-panel rounded-4 overflow-hidden">
        <div class="px-3 pt-3">
          <div class="controls-library-section-title text-s">Remediation - what happens when a control fails</div>
          <div class="controls-library-section-subtitle text-xs">Every failing or partially-effective control and its
            corrective actions. Click a row to open that remediation action.</div>
        </div>
        <div class="table-responsive">
          <table class="table controls-library-table controls-library-table--remediation align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3">Control</th>
                <th>Remediation action</th>
                <th>Owner</th>
                <th>Due</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in remediation_rows"
                :key="row.id"
                class="controls-library-row"
                role="button"
                tabindex="0"
                @click="open_remediation_drawer(row)"
                @keydown.enter.prevent="open_remediation_drawer(row)"
                @keydown.space.prevent="open_remediation_drawer(row)"
              >
                <td class="ps-3">
                  <div class="controls-library-id">{{ row.control }}</div>
                </td>
                <td>
                  <div class="controls-library-control">{{ row.action }}</div>
                  <div class="controls-library-control-subtitle controls-library-control-subtitle--dark">{{ row.subtitle
                    }}</div>
                </td>
                <td>{{ row.owner }}</td>
                <td>{{ row.due }}</td>
                <td><span class="badge complyon-badge controls-library-badge" :class="row.status.class">{{
                    row.status.label }}</span></td>
                <td class="controls-library-arrow-cell"><i class="bi bi-chevron-right"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>

  <div
    v-if="active_library_drawer"
    class="command-centre-drawer-backdrop"
    @click="close_control_drawer"
  >
    <aside
      class="command-centre-drawer controls-library-drawer"
      role="dialog"
      aria-modal="true"
      :aria-label="active_library_drawer.title"
      @click.stop
    >
      <header class="command-centre-drawer-header border-bottom">
        <div class="d-flex align-items-start justify-content-between gap-3">
          <div class="min-w-0">
            <div class="command-centre-drawer-kicker">{{ active_library_drawer.section }}</div>
            <div class="command-centre-drawer-title mt-1">{{ active_library_drawer.title }}</div>
            <div class="command-centre-drawer-subtitle mt-1">{{ active_library_drawer.subtitle }}</div>
          </div>
          <div class="d-flex align-items-center gap-2 flex-shrink-0">
            <span class="badge controls-library-badge" :class="active_library_drawer.status_class">{{ active_library_drawer.status }}</span>
            <button type="button" class="btn btn-link p-0 controls-library-modal-close" @click="close_control_drawer" aria-label="Close drawer">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </header>

      <div class="command-centre-drawer-body">
        <section class="mb-3">
          <div class="row g-2 command-centre-drawer-details-list">
            <div v-for="detail in active_library_drawer.details" :key="detail.label" class="col-6">
              <div class="command-centre-drawer-meta border rounded-3 p-3 h-100">
                <div class="command-centre-drawer-meta-label text-uppercase">{{ detail.label }}</div>
                <div class="command-centre-drawer-meta-value mt-1" :class="detail.value_class">{{ detail.value }}</div>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">{{ active_library_drawer.kind === 'remediation' ? 'Remediation objective' : 'Control objective' }}</div>
          <div class="command-centre-drawer-item">
            <div class="command-centre-drawer-item-title mb-2">{{ active_library_drawer.objective }}</div>
            <div class="command-centre-drawer-item-subtitle">{{ active_library_drawer.summary }}</div>
          </div>
        </section>

        <section v-if="active_library_drawer.connected_records.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Connected records</div>
          <div class="row g-2">
            <div v-for="record in active_library_drawer.connected_records" :key="`${record.type}-${record.title}`" class="col-12 col-sm-6">
              <div class="command-centre-drawer-item h-100">
                <div class="d-flex align-items-start gap-2">
                  <span class="command-centre-drawer-item-icon" :class="drawer_tone_class(record.tone)">
                    <i class="bi" :class="drawer_icon_for_type(record.type)"></i>
                  </span>
                  <div class="min-w-0">
                    <div class="command-centre-drawer-item-title">{{ record.type }}</div>
                    <div class="command-centre-drawer-item-subtitle">{{ record.title }}</div>
                    <div class="command-centre-drawer-item-meta">{{ record.subtitle }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="active_library_drawer.risks.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Risks this control prevents</div>
          <div class="d-flex flex-wrap gap-2">
            <span
              v-for="risk in active_library_drawer.risks"
              :key="risk.label"
              class="badge rounded-pill border command-centre-drawer-chip"
              :class="drawer_chip_class(risk.kind)"
            >
              {{ risk.label }}
            </span>
          </div>
        </section>

        <section v-if="active_library_drawer.obligations.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Obligation this control proves</div>
          <div class="d-flex flex-wrap gap-2">
            <span
              v-for="obligation in active_library_drawer.obligations"
              :key="obligation.label"
              class="badge rounded-pill border command-centre-drawer-chip"
              :class="drawer_chip_class(obligation.kind)"
            >
              {{ obligation.label }}
            </span>
          </div>
        </section>

        <section v-if="active_library_drawer.policies.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Policies that create this rule</div>
          <div class="d-flex flex-wrap gap-2">
            <span
              v-for="policy in active_library_drawer.policies"
              :key="policy.label"
              class="badge rounded-pill border command-centre-drawer-chip"
              :class="drawer_chip_class(policy.kind)"
            >
              {{ policy.label }}
            </span>
          </div>
        </section>

        <section v-if="active_library_drawer.evidence.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Evidence required</div>
          <div class="d-flex flex-wrap gap-2">
            <span
              v-for="item in active_library_drawer.evidence"
              :key="item.label"
              class="badge rounded-pill border command-centre-drawer-chip"
              :class="drawer_chip_class(item.kind)"
            >
              {{ item.label }}
            </span>
          </div>
        </section>

        <section v-if="active_library_drawer.tests.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Control testing results</div>
          <div class="command-centre-drawer-timeline">
            <div v-for="(test, index) in active_library_drawer.tests" :key="`${test.label}-${test.date}`" class="command-centre-drawer-timeline-item">
              <span class="command-centre-drawer-timeline-badge" :class="drawer_tone_class(test.tone)">
                <i class="bi" :class="index === 0 ? 'bi-check2' : 'bi-check-lg'"></i>
              </span>
              <div class="command-centre-drawer-timeline-content">
                <div class="command-centre-drawer-item-title">{{ test.label }}</div>
                <div class="command-centre-drawer-timeline-meta">{{ test.subtitle }}</div>
                <div class="command-centre-drawer-timeline-meta">{{ test.date }}</div>
              </div>
              <span class="command-centre-drawer-timeline-line"></span>
            </div>
          </div>
        </section>

        <section v-if="active_library_drawer.escalation.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">If this control fails - escalation</div>
          <div class="d-flex flex-column gap-2">
            <div v-for="record in active_library_drawer.escalation" :key="`${record.type}-${record.title}`" class="command-centre-drawer-item">
              <div class="d-flex align-items-start gap-2">
                <span class="command-centre-drawer-item-icon" :class="drawer_tone_class(record.tone)">
                  <i class="bi" :class="drawer_icon_for_type(record.type)"></i>
                </span>
                <div class="min-w-0">
                  <div class="command-centre-drawer-item-title">{{ record.type }}</div>
                  <div class="command-centre-drawer-item-subtitle">{{ record.title }}</div>
                  <div class="command-centre-drawer-item-meta">{{ record.subtitle }}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="active_library_drawer.remediation.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Remediation actions</div>
          <div class="d-flex flex-column gap-2">
            <div v-for="record in active_library_drawer.remediation" :key="`${record.type}-${record.title}`" class="command-centre-drawer-item">
              <div class="d-flex align-items-start gap-2">
                <span class="command-centre-drawer-item-icon" :class="drawer_tone_class(record.tone)">
                  <i class="bi" :class="drawer_icon_for_type(record.type)"></i>
                </span>
                <div class="min-w-0">
                  <div class="command-centre-drawer-item-title">{{ record.title }}</div>
                  <div class="command-centre-drawer-item-subtitle">{{ record.subtitle }}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <footer class="command-centre-drawer-footer border-top">
        <div class="d-flex align-items-center justify-content-end gap-2">
          <button type="button" class="btn btn-link text-decoration-none" @click="close_control_drawer">Close</button>
          <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2" @click="open_control_modal(active_library_drawer.row)">
            <i class="bi bi-pencil-square"></i>
            <span>Edit control</span>
          </button>
        </div>
      </footer>
    </aside>
  </div>

  <div
    v-if="control_modal_open"
    class="controls-library-modal-backdrop"
    @click.self="close_control_modal"
  >
    <section class="controls-library-modal-shell" role="dialog" aria-modal="true" :aria-label="control_modal_mode === 'edit' ? 'Edit control' : 'New control'">
      <header class="controls-library-modal-header d-flex align-items-start justify-content-between gap-3 border-bottom">
        <div>
          <div class="controls-library-modal-title">{{ control_modal_mode === 'edit' ? 'Edit control' : 'New control' }}</div>
          <div class="controls-library-modal-subtitle">Risks, policies, evidence and remediation are managed inside the control detail.</div>
        </div>
        <button type="button" class="btn btn-link p-0 controls-library-modal-close" @click="close_control_modal" aria-label="Close modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="controls-library-modal-body">
        <div class="row g-3">
          <div class="col-12">
            <label class="controls-library-modal-label">Control name</label>
            <input v-model="control_modal_form.control_name" type="text" class="form-control controls-library-modal-input" placeholder="e.g. No supplier paid without valid tax, banking & contract">
          </div>

          <div class="col-12">
            <label class="controls-library-modal-label">Description</label>
            <textarea v-model="control_modal_form.description" rows="3" class="form-control controls-library-modal-textarea" placeholder="What the control requires"></textarea>
          </div>

          <div class="col-12">
            <label class="controls-library-modal-label">Control objective - what risk it prevents</label>
            <textarea v-model="control_modal_form.objective" rows="3" class="form-control controls-library-modal-textarea" placeholder="e.g. Prevents supplier & payment fraud"></textarea>
          </div>

          <div class="col-12 col-md-6">
            <label class="controls-library-modal-label">Category</label>
            <select v-model="control_modal_form.category" class="form-select controls-library-modal-select">
              <option v-for="option in control_category_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="controls-library-modal-label">Control owner</label>
            <input v-model="control_modal_form.owner" type="text" class="form-control controls-library-modal-input" placeholder="Role - name">
          </div>

          <div class="col-12 col-md-6">
            <label class="controls-library-modal-label">Testing frequency</label>
            <select v-model="control_modal_form.testing_frequency" class="form-select controls-library-modal-select">
              <option v-for="option in control_frequency_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="controls-library-modal-label">Latest result</label>
            <select v-model="control_modal_form.latest_result" class="form-select controls-library-modal-select">
              <option v-for="option in control_result_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="controls-library-modal-label">Next due</label>
            <input v-model="control_modal_form.next_due" type="text" class="form-control controls-library-modal-input" placeholder="e.g. Monthly">
          </div>
        </div>
      </div>

      <footer class="controls-library-modal-footer d-flex align-items-center justify-content-end gap-2 border-top">
        <button type="button" class="btn btn-link controls-library-modal-cancel text-decoration-none" @click="close_control_modal">Cancel</button>
        <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2" @click="save_control_modal">
          <i class="bi bi-plus"></i>
          <span>{{ control_modal_mode === 'edit' ? 'Save changes' : 'Create' }}</span>
        </button>
      </footer>
    </section>
  </div>
</div>
